// extracted by mini-css-extract-plugin
module.exports = {"tagSearchResultWrapper":"styles_tagSearchResultWrapper__19xia","searchIconWrapper":"styles_searchIconWrapper__36aFI"};